/** Single source of truth for the dimensions phase order (drives current_phase). */
export const DIMENSION_PHASE_ORDER = [
  'init', 'loading', 'pre_dedup', 'ai_validate', 'ai_create',
  'post_dedup', 'compliance', 'final_dedup', 'sync', 'complete',
] as const;

export type DimensionPhase = (typeof DIMENSION_PHASE_ORDER)[number];

export type LayerState = 'pending' | 'active' | 'done';

/**
 * State of a dedup layer (identified by its phase id) relative to the live phase.
 * An undefined currentPhase (completed job / no live stream) renders every layer
 * as done.
 */
export function layerState(
  layerPhase: DimensionPhase,
  currentPhase?: string,
): LayerState {
  if (!currentPhase) return 'done';
  const cur = DIMENSION_PHASE_ORDER.indexOf(currentPhase as DimensionPhase);
  const layer = DIMENSION_PHASE_ORDER.indexOf(layerPhase);
  if (cur < 0) return 'pending';
  if (cur > layer) return 'done';
  if (cur === layer) return 'active';
  return 'pending';
}
